(function($){
    'use strict';

    var shoppingCartArray = [];

    $('.shoppingcart--item input').each(function() {
        shoppingCartArray.push($(this).val());
    });

    // Show update button
    $('.shoppingcart--item input').on('keyup change', function() {
        $(this).parent().find('.shoppingcart--item_update').show();
    });

    // GTM Tracking
    function gtmUpdateQuantity(initValue,newValue,element){
                        
        //console.log('targetElm:',targetElm);
        var data = gtmTracking.getGtmElementData(element);   
        element.dataset.gtmQuantity = newValue; // here we update the initial data values since they cart is updated via AJAX

        data.quantity = Math.abs(newValue - initValue); //here we update the quantity field -ve means we are removing products
        //console.log('data:',data); 

        if (initValue > newValue ) {
            //var updateEvent = 'removeFromCart';
            // Measure the removal of a product from a shopping cart.
            dataLayer.push({ ecommerce: null });

            dataLayer.push({
                'event': 'removeFromCart',
                'ecommerce': {
                'remove': { // 'remove' actionFieldObject measures.
                    'products': [data]
                }
                }
            });

            // GA4 events
            dataLayer.push({
                event : "remove_from_cart",
                ecommerce : {
                    items : [ data ]
                }
            });

        } else {
            //var updateEvent = 'addToCart';
            dataLayer.push({ ecommerce: null });

            dataLayer.push({
                'event': 'addToCart',
                'ecommerce': {
                'currencyCode': 'AUD',
                'add': { // 'add' actionFieldObject measures.
                'products': [data]
                    }
                }
            });

            // GA4 events
            dataLayer.push({
                event : "add_to_cart",
                ecommerce : {
                    currency : "AUD",
                    items : [ data ]
                }
            });
        }

        //console.log('Update Cart Data: ', data);

    }

    $('.shoppingcart--item_update').on('click', function(e) {
        //console.log('click update');
        e.preventDefault();
        var $selectedInput = $(this).parent().find('.text.num.styled');        
        var $gtmDataElement =  $(e.target).parents('.gtm-product-data')[0];
        var initValue = $selectedInput.attr('init-val-data');
        var newValue = $selectedInput.val();
        var inputName = $selectedInput.attr('id').split('_')[1];
        var $submitButtons = $('.next-button');
        var $removeButtons = $(this).parent().parent().parent().find('.shoppingcart--item_remove');
        // changed
        if (newValue !== initValue) {
            //disable submit button
            $submitButtons.prop('disabled', true).addClass('product--cart__disabled');
            $selectedInput.prop('disabled', true);

            // get the cart url
            var cartURL = window.location.protocol + '//' + window.location.host + '/' + 'store/shopping-cart?SQ_DESIGN_NAME=blank';

            // initial load of the cart page
            var removeURL = window.location.protocol + '//' + window.location.host + '/' + 'store/shopping-cart/?buy[' + inputName + ']=-' + newValue;

            $.ajax({
                url:     cartURL + '&buy[' + inputName + ']=' + (newValue - initValue),
                success: function(data) {

                    //enable submit button
                    $submitButtons.prop('disabled', false).removeClass('product--cart__disabled');
                    $selectedInput.prop('disabled', false).blur();

                    // Update Remove Btn URL
                    $removeButtons.attr('href', removeURL);

                    var $response=$(data);
                    $selectedInput.attr('init-val-data', newValue);
                    $('.shoppingcart--item_price.total').text('$' + $response.filter('#cartTotal').text());

                    var gst = parseFloat($response.filter('#cartTotal').text()/11).toFixed(2);
                    $('.gst').text('$' + gst);

                    // hide update button
                    $('.shoppingcart--item_update').hide();

                    //push to GTM dataLayer
                    gtmUpdateQuantity(initValue,newValue,$gtmDataElement);
                }
            });
        }
    });



    // show discount row if it's more than 0
    var discountNumber = parseInt($('.discount-value').text().replace('$',''), 10);

    if ( discountNumber > 0) {
        $('.subtotal.discount').removeClass('hidden');
        $('.promo-applied').removeClass('hidden');
        // hide the field
        $('.promo-title').hide();
        $('#ecommerce_checkout_901_promotional_code').hide();
        $('[name*=apply_promotional_code]').hide();
    }


    // show shipping row if it's more than 0
    const currentStep = $('.checkout-tabs__item.current .checkout-tabs__link-step').text();
    const deliveryInterfaceItems = $('.gtm-product-data');
    const shippingNumber = parseFloat($('.shipping-value').text().replace('$',''));
    var shippingWeight = 0;
    
    if (deliveryInterfaceItems.length > 0) {
        deliveryInterfaceItems.each(function() {
            shippingWeight += $(this).data('weight');
        });
    }

    if (shippingWeight > 0) {
        if (currentStep === '2' && shippingNumber === 0) {
            var totalElement = $('.total h3');
            var totalNumber = parseFloat(totalElement.text().replace('$',''));
            totalNumber = totalNumber + 14.95;
            totalElement.text(`$${totalNumber.toFixed(2)}`);
            $('.shipping-value').text('$14.95');
        }

        $('.subtotal.shipping').show();
    }
    
    $('.subtotal.total').show();

}(jQuery));
